/* eslint-disable */
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Typography, Box, IconButton, Tooltip } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from "@material-ui/core/Button";
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import CSVReader from 'react-csv-reader';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { string } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import SearchNotFound from '../../../SearchNotFound';
import { PhoneNumberUtil } from 'google-libphonenumber';
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function FarmerBulkUpload(props) {
  const phoneNumberUtil = PhoneNumberUtil.getInstance();
  const navigate = useNavigate();
  const screenCode = 'FARMERBULKUPLOAD';
  const [isUploadButtonEnable, setIsUploadButtonEnable] = useState(true);
  const [isTableEnable, setIsTableEnable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [farmersCSVData, setFarmersCSVData] = useState([]);
  const [isFileChosen, setIsFileChosen] = useState(false);
  const [fileInfo, setFileInfo] = useState({});
  const [farmerBulkUpload, setFarmerBulkUpload] = useState([]);
  const [farmerNICExistsList, setFarmerNICExistsList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: 0
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Upload",
    pageheadername: "Farmer Bulk Upload"
  });

  const ProductSaveSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        UpdateProduct(values, pageProps.editingID)
      } else {
        trackPromise(saveFarmer());
      }
    },
  });

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - farmerBulkUpload.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function saveFarmer() {
    setIsLoading(true);
    let duplicate = duplicateCheck();
    let invalideNumbers = mobileNumberCheck();
    if (farmerBulkUpload.length > 0) {
      if (duplicate.length == 0) {
        if (invalideNumbers.length == 0) {
          var res = await services.saveFarmer(farmerBulkUpload);
          if (res.statusCode == 'Success') {
            if (res.data.length > 0) {
              toast.success("Farmer NIC Already Exists");
              setFarmerBulkUpload(res.data);
              setFarmerNICExistsList(res.data);
              setTimeout(() => {
                setIsLoading(false);
              }, 2000);
            }
            else {
              toast.success(res.message);
              setTimeout(() => {
                clearAll();
                setIsLoading(false);
              }, 600);
            }
          }
          else {
            toast.error(res.message);
            setTimeout(() => {
              setIsLoading(false);
            }, 2000);
          }
        }
        else {
          toast.error("Invalid " + invalideNumbers.length + " Mobile Numbers Detected.");
          setTimeout(() => {
            setIsLoading(false);
          }, 2000);
        }
      }
      else {
        toast.error("Duplicate NIC Detected.");
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    }
    else {
      toast.error("Please select a correct file.");
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  }

  async function assginFarmer(farmerData, type) {
    if (type.type === "text/csv") {
      setFarmerBulkUpload([])
      let datarest = await Promise.all(farmerData.map(async data => {
        var farmerDetails = {
          farmerID: 0,
          groupID: parseInt(formik.values.groupID),
          operationEntityID: parseInt(formik.values.operationEntityID),
          nic: data.nic.toUpperCase(),
          farmerType: parseInt(data.supplierType),
          navisionNo: data.navisionNo,
          modeofOperation: parseInt(data.modeofOperation),
          title: parseInt(data.title),
          givenName: data.preferredName,
          firstName: data.surName,
          lastName: data.fullName,
          gender: parseInt(data.gender),
          maritialStatus: parseInt(data.maritialStatus),
          education: parseInt(data.education),
          address1: data.address1,
          address2: data.address2,
          address3: data.address3,
          province: parseInt(data.province),
          district: parseInt(data.district),
          city: parseInt(data.city),
          dsDivision: parseInt(data.dsDivision),
          gnDivision: parseInt(data.gnDivision),
          businessName: data.businessName,
          brNumber: data.brNumber,
          joingDate: data.joingDate.split('T')[0],
          mobileNumber: data.mobileNumber == "" ? "" : data.mobileNumber,
          createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
          isActive: true,
        }
        setFarmerBulkUpload(farmerBulkUpload => [...farmerBulkUpload, farmerDetails]);
        setIsTableEnable(false)
      }))

      var errorList = [];
      datarest.map((itemx) => {
        if (itemx != undefined) {
          errorList.push(itemx);
        }
      })
      setFarmersCSVData(errorList);

    }
    else {
      toast.error(type.name + " is not valid . please select a CSV file.");
      setTimeout(() => {
      }, 3000);
    }
  }

  function duplicateCheck() {
    let newRes = _.cloneDeep(farmerBulkUpload);
    var result = [];
    var duplicates = [];
    newRes.forEach(x => {

      var duplicateNIC = result.find(y => y.nic === x.nic);
      if (duplicateNIC != undefined) {
        duplicates.push(duplicateNIC);
      }
      result.push(x);
    });
    return duplicates;
  }

  function mobileNumberCheck() {
    let newRes = _.cloneDeep(farmerBulkUpload);
    var duplicates = [];
    newRes.forEach(x => {
      if (x.mobileNumber == "") {
        duplicates.push(x);
      }
      else {
        const number = phoneNumberUtil.parseAndKeepRawInput(x.mobileNumber.toString(), 'LK');
        if (!phoneNumberUtil.isValidNumber(number)) {
          duplicates.push(x);
        }
      }
    })
    return duplicates;
  }

  async function clearAll() {
    var farmerDetails = {
      farmerID: 0,
      groupID: 0,
      operationEntityID: 0,
      nic: "",
      farmerType: 0,
      navisionNo: "",
      modeofOperation: 0,
      title: 0,
      givenName: "",
      firstName: "",
      lastName: "",
      gender: 0,
      maritialStatus: 0,
      education: 0,
      address1: "",
      address2: "",
      address3: "",
      province: 0,
      district: 0,
      city: 0,
      dsDivision: 0,
      gnDivision: 0,
      businessName: "",
      brNumber: "",
      joingDate: "",
      mobileNumber: "0112505224",
      createdBy: 0,
      isActive: true
    }
    setFarmerBulkUpload([farmerDetails]);
    //setFileInfo({});
    setFarmerNICExistsList([]);
    setIsFileChosen(false);
    setIsUploadButtonEnable(true);
    setIsTableEnable(true);
    document.querySelector('.csv-input').value = '';
  }

  const papaparseOptions = {
    header: true,
    dynamicTyping: false,
    quoteChar: '"',
    skipEmptyLines: true,
    parseNumbers: true,
    transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '')
  };

  const handleForce = (data, fileInfo) => {
    //if (farmersCSVData != null) {
    setIsFileChosen(true);
    setFileInfo(fileInfo);
    assginFarmer(data, fileInfo);
    confirmUpload(data, fileInfo);
    //}
  }

  function confirmUpload(data, fileInfo) {
    setFarmersCSVData(data);
  }

  useEffect(() => {
    checkUploadButton();
  }, [formik.values.groupID, formik.values.operationEntityID]);

  function checkUploadButton() {
    if (formik.values.groupID != 0 && formik.values.operationEntityID != 0) {
      setIsUploadButtonEnable(false);
    }
  }

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMERBULKUPLOAD');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    trackPromise(GetAllGroups());
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  function generateGroupForDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        items.push(<MenuItem key={x.groupID} value={x.groupID}>{x.groupName}</MenuItem>)
      });
    }
    return items
  }

  function generateOperationEntityForDropDownMenu(data) {
    let items = []
    if (data != null) {
      data.forEach(x => {
        x.factoryType == 2 ? items.push(<MenuItem key={x.factoryID} value={x.factoryID}>{x.factoryName}</MenuItem>) :
          null
      });
    }
    return items
  }

  const csvHeaders = [
    { label: "nic", key: "nic" },
    { label: "supplierType", key: "farmerType" },
    { label: "modeofOperation", key: "modeofOperation" },
    { label: "navisionNo", key: "navisionNo" },
    { label: "title", key: "title" },
    { label: "preferredName", key: "givenName" },
    { label: "fullName", key: "lastName" },
    { label: "surName", key: "firstName" },
    { label: "gender", key: "gender" },
    { label: "maritialStatus", key: "maritialStatus" },
    { label: "education", key: "education" },
    { label: "joingDate", key: "joingDate" },
    { label: "address1", key: "address1" },
    { label: "address2", key: "address2" },
    { label: "address3", key: "address3" },
    { label: "province", key: "province" },
    { label: "district", key: "district" },
    { label: "city", key: "city" },
    { label: "dsDivision", key: "dsDivision" },
    { label: "gnDivision", key: "gnDivision" },
    { label: "businessName", key: "businessName" },
    { label: "brNumber", key: "brNumber" },
    { label: "mobileNumber", key: "mobileNumber" }
  ];

  const csvData = [
    {
      nic: "", farmerType: "", modeofOperation: "", navisionNo: "", title: "", givenName: "", firstName: "", lastName: "", gender: "", maritialStatus: "", education: "", address1: "", address2: "", address3: "", province: "", district: "", city: "", dsDivision: "", gnDivision: "", businessName: "", brNumber: "", joingDate: "",
      mobileNumber: ""
    },
  ];

  const csvData2 = [
    {
      nic: "000000000V", farmerType: "1", modeofOperation: "1", navisionNo: "F01254", title: "1", givenName: "samplePreferredName", firstName: "sampleSurName", lastName: "sampleFullName", gender: "1", maritialStatus: "1", education: "1",
      address1: "sampleAddress1", address2: "sampleAddress2", address3: "sampleAddress3", province: "1", district: "1", city: "1", dsDivision: "1", gnDivision: "1", businessName: "businessName", brNumber: "123456", joingDate: "2022-01-01T00:00:01.001", mobileNumber: "0111111111"
    },
  ];

  return (
    <>
      <LoadingComponent />
      <Page title="Farmer Bulk Upload  |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard"
            btname="Back"
            pageName={pageProps.pageheadername}
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    name="groupID"
                    value={formik.values.groupID}
                    onChange={formik.onChange}
                    //disabled={!isUploadButtonEnable}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value="0"> Select Group</MenuItem>
                    {generateGroupForDropDownMenu(groupList)}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    name="operationEntityID"
                    value={formik.values.operationEntityID}
                    onChange={formik.onChange}
                    //disabled={!isUploadButtonEnable}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}> Select Fresh Collection Center</MenuItem>
                    {generateOperationEntityForDropDownMenu(operationEntityList)}
                  </TextField>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button variant="contained" color='secondary' component="span"
                    disabled={formik.values.groupID == 0 || formik.values.operationEntityID == 0 ? true : false}>
                    <CSVReader
                      label={isFileChosen ? 'File Chosen' : 'Choose File'}
                      inputStyle={{ display: 'none' }}
                      onFileLoaded={handleForce}
                      parserOptions={papaparseOptions}
                      inputId="react-csv-reader-input"
                      cssClass="csv-reader-input"
                    />
                  </Button>
                  {isFileChosen ? <span>{fileInfo.name}</span> : null}
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Farmer Bulk Template.csv"}
                    >
                      Template
                    </CSVLink>
                  </Button>
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData2}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Farmer Bulk Sample Template.csv"}
                    >
                      Sample Data
                    </CSVLink>
                  </Button>
                </Stack>
                <br />
                <Divider variant="middle" />
                <br />
                {duplicateCheck().length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Typography variant="h7" gutterBottom>
                      Duplicate NIC Count : {duplicateCheck().length * 2}
                    </Typography>
                  </Stack> : null}
                {farmerNICExistsList.length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Typography variant="h7" gutterBottom>
                      Farmer NIC Exists List
                    </Typography>
                  </Stack> : null}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">Farmer Name</TableCell>
                              <TableCell align="left">Primary Number</TableCell>
                              <TableCell align="left">NIC</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(rowsPerPage > 0
                              ? farmerBulkUpload.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : farmerBulkUpload
                            ).map((row, index, array) => {
                              const isDuplicate = array.findIndex((item) => item.nic === row.nic) !== index;
                              return (
                                <TableRow key={row.givenName} style={{
                                  backgroundColor: isDuplicate ? '#FFEBEE' : 'inherit'
                                }}>
                                  <TableCell align="left">{row.givenName}</TableCell>
                                  <TableCell align="left">
                                    {row.mobileNumber == "" ? (
                                      <div style={{ backgroundColor: "#FFEBEE", padding: "10px", borderRadius: "5px" }}>
                                        <Tooltip title={"Mobile Number not found."}>
                                          <span>{"Mobile Number not found."}</span>
                                        </Tooltip>
                                      </div>
                                    ) : (
                                      (phoneNumberUtil.isValidNumber(phoneNumberUtil.parseAndKeepRawInput(row.mobileNumber.toString(), 'LK')) == false) ?
                                        <div style={{ backgroundColor: "#FFEBEE", padding: "10px", borderRadius: "5px" }}>
                                          <span>{row.mobileNumber + ' Invalid Number'}</span>
                                        </div>
                                        :
                                        row.mobileNumber
                                    )}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.nic === "" ? (
                                      <div style={{ backgroundColor: "#FFEBEE", padding: "10px", borderRadius: "5px" }}>
                                        <Tooltip title={"NIC Number not found."}>
                                          <span>{"NIC Number not found."}</span>
                                        </Tooltip>
                                      </div>
                                    ) : (
                                      row.nic
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={6}
                                count={farmerBulkUpload.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    'aria-label': 'rows per page',
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack> : <SearchNotFound searchQuery="Farmer Bulk Upload" />}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <LoadingButton
                      size="small"
                      type="button"
                      color='error'
                      variant="outlined"
                      disabled={pageProps.isEdit}
                      onClick={() => clearAll()}
                    >
                      Clear
                    </LoadingButton>
                    <LoadingButton
                      size="small"
                      type="submit"
                      color='secondary'
                      variant="outlined"
                      disabled={isTableEnable}
                      loading={isLoading}
                    >
                      {pageProps.submitButtonName}
                    </LoadingButton>
                  </Stack> : null}
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}